export enum EKwikUIProgressCircleSize {
  XS = "xs",
  S = "s",
  M = "m",
  L = "l",
  XL = "xl"
}
export const VKwikUIProgressCircleSize = [
  EKwikUIProgressCircleSize.XS,
  EKwikUIProgressCircleSize.S,
  EKwikUIProgressCircleSize.M,
  EKwikUIProgressCircleSize.L,
  EKwikUIProgressCircleSize.XL
] as const;

export type TKwikUIProgressCircleSize =
  (typeof VKwikUIProgressCircleSize)[number];
